import React from 'react'

export default function Notfound() {
    return (
        <p className=' vh-100 text-danger bg-dark h1 d-flex align-items-center justify-content-center width: 100%'>Notfound 404</p>
    )
}
